import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { useGroups } from 'root/src/client/v2/auth/hooks/useGroups';
export function useIsViewer() {
    const { groups } = useGroups();
    const isViewer = groups.includes(AuthGroup.Viewer);
    return {
        isViewer,
    };
}
